import rightImgDemo from "images/BecomeAnAuthorImg.png";
import { useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import FaqLandlords from "./FaqLandlords";
import Faqtenats from "./Faqtenats";
import ButtonSecondary from "shared/Button/ButtonSecondary";

export default function FAQPage() {
    const [activeTab, setActiveTab] = useState<"landlords" | "tenants" | null>("landlords");

    const handleToggle = (tab: "landlords" | "tenants") => {
        setActiveTab(prev => (prev === tab ? null : tab));
    };

    return (
        <div className="container">
            <div className="h-[50vh] w-full flex flex-col md:flex-row items-center justify-between px-8 container">
                <div className="max-w-lg text-center md:text-left">
                    <h1 className="text-4xl font-bold text-gray-800 mb-4 dark:text-white">
                        FAQs
                    </h1>
                    <p className="text-gray-600 dark:text-white">
                        Have questions? Here you'll find the answers most valued by our partners,
                        along with access to step-by-step instructions and support.
                    </p>
                </div>
                <div className="mt-6 md:mt-0 max-w-sm w-full">
                    <NcImage src={rightImgDemo} className="w-full h-auto object-contain" />
                </div>
            </div>
            <div className="mx-auto px-8">
                <div className="flex flex-col sm:flex-row justify-start gap-4 pt-8">
                    {activeTab === "landlords" ? (
                        <ButtonPrimary onClick={() => handleToggle("landlords")}>
                            Hide Host Info
                        </ButtonPrimary>
                    ) : (
                        <ButtonSecondary onClick={() => handleToggle("landlords")}>
                            Information for Hosts
                        </ButtonSecondary>
                    )}
                    {activeTab === "tenants" ? (
                        <ButtonPrimary onClick={() => handleToggle("tenants")}>
                            Hide Tenant Info
                        </ButtonPrimary>
                    ) : (
                        <ButtonSecondary onClick={() => handleToggle("tenants")}>
                            Information for Tenants
                        </ButtonSecondary>
                    )}
                </div>
                <div className="mt-10">
                    {activeTab === "landlords" && <FaqLandlords />}
                    {activeTab === "tenants" && <Faqtenats />}
                </div>
            </div>
        </div>
    );
}
